module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-sm-5 col-sm-offset-4"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "data-vv-rules": "required|alpha_spaces",
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('name')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')) + " " + _vm._s(_vm.error_here.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address),
      expression: "user.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "data-vv-rules": "required",
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.user.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('address')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|numeric",
      "data-vv-delay": "500",
      "name": "phone",
      "type": "number",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('phone')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.error_here.phone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|email",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.error_here.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required",
      "data-vv-delay": "500",
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [(_vm.password_error_match != ' ') ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.password_error_match))]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.cpassword),
      expression: "user.cpassword"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-rules": "required|confirmed:password",
      "data-vv-delay": "1500",
      "name": "password_confirmation",
      "type": "password",
      "placeholder": "Password, Again",
      "data-vv-as": "password"
    },
    domProps: {
      "value": (_vm.user.cpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.cpassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.has('password_confirmation')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))]) : _vm._e()]), _vm._v(" "), ((_vm.ref_code != '' && _vm.ref_code != undefined)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Referral Code : " + _vm._s(_vm.ref_code))])]) : _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Referral Code(enter referral code if you have one)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ref_code),
      expression: "user.ref_code"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "type": "number",
      "pattern": "/^-?\\d+\\.?\\d*$/",
      "onKeyPress": "if(this.value.length==5) return false;"
    },
    domProps: {
      "value": (_vm.user.ref_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.ref_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_agree),
      expression: "terms_agree"
    }],
    attrs: {
      "id": "checkbox1",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_agree) ? _vm._i(_vm.terms_agree, "1") > -1 : (_vm.terms_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_agree = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox1"
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.terms_agree) ? _c('button', {
    staticClass: "btn btn-warning btn-block m-t-xs",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center m-t-xs text-sm"
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])])])])])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#22baae"
    }
  }, [_vm._v("create your cityneeds account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Confirm Password"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v(" I agree to Cityneeds Technologies Limited "), _c('a', {
    attrs: {
      "href": "terms"
    }
  }, [_vm._v("Terms & Service")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53252066"}!./src/components/Register/template.html
// module id = 292
// module chunks = 0